/**
 * Launch product flags. Keep in sync with
 * BetBond/src/config/products.js and betMateBackEnd/src/config/products.js.
 */
export const PRODUCTS = {
  p2p: true,
  chat: true,
  leaderboard: true,
  tips: true,
};

export const HOME_PATH = "/app/p2p";

export function isProductEnabled(product) {
  if (!product) return true;
  return PRODUCTS[product] === true;
}

/** Hub / create paths only — paused product hubs return a product key. */
export function appPathProduct(pathname = "") {
  if (pathname === "/app/bethouse" || pathname.startsWith("/app/bethouse/create")) {
    return "house";
  }
  if (pathname === "/app/bethouse/manage") return "house";
  if (pathname === "/app/bond-play") return "play";
  if (pathname === "/app/bond-predict") return "predict";
  if (pathname.startsWith("/app/predictions")) return "tips";
  return null;
}

export function isPausedAppPath(pathname) {
  const product = appPathProduct(pathname);
  return Boolean(product) && !isProductEnabled(product);
}
